import React, { useState, useEffect } from 'react';
import ActionBar from '../layout/ActionBar';
import { NavLink, useNavigate } from 'react-router-dom';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { loadPromotions } from '../../actions/promotionActions';
import { CommaNumber_NoDecimal, hexToRgbA } from '../../util/formatter';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { usePageTitle } from '../../util/pageTitle';

function PromotionCalendar() {
  usePageTitle(['Promotions calendar']);
  const navigate = useNavigate();
  const [reload, setReload] = useState(undefined);
  const { t } = useTranslation();
  const [events, setEvents] = useState<any>();
  const [dateRange, setDateRange] = useState<{ start: string; end: string }>();

  useEffect(() => {
    const loadData = async () => {
      try {
        const promotions = await loadPromotions({
          filters: {
            promotionDateFrom: dateRange!.start,
            promotionDateTo: dateRange!.end,
          },
          _scopes: undefined,
          _sort: '',
          _page: 0,
          _limit: 10000,
          _order: 'asc',
        });

        if (!promotions.data) {
          return;
        }

        const data = promotions.data.map((item: any) => ({
          title: item.name,
          start: item.start,
          end: item.end,
          color: item.keyProviderColourHex
            ? hexToRgbA(item.keyProviderColourHex, 0.5)
            : 'rgba(22,190,239,0.5)',
          extendedProps: item,
        }));

        setEvents(data);
      } catch (e: any) {
        toast.error(e.message ? e.message : t('Failed to get promotions'));
      }
    };

    if (!dateRange) {
      return;
    }

    loadData();
  }, [dateRange, t]);

  function renderEventContent(eventInfo: any) {
    return (
      <>
        <div>
          <b>{eventInfo.event.title}</b>
        </div>
        <div>{eventInfo.event.extendedProps.keyProviderName}</div>
        <div>
          {CommaNumber_NoDecimal(eventInfo.event.extendedProps.numberOfSKUs)}{' '}
          skus
        </div>
      </>
    );
  }

  const handleDates = (rangeInfo: any) => {
    setDateRange({ start: rangeInfo.startStr, end: rangeInfo.endStr });
  };

  const handleEventClick = (eventClickInfo: any) => {
    if (eventClickInfo?.event.extendedProps) {
      navigate(`/promotion/${eventClickInfo.event.extendedProps.id}`);
    }
  };

  return (
    <>
      <ActionBar
        breadcrumb={[
          {
            link: '/promotions',
            label: t('Promotion calendar'),
          },
        ]}
      >
        <NavLink className="btn btn-primary" to="/promotion/add">
          {t('Add promotion')}
        </NavLink>
      </ActionBar>
      <FullCalendar
        plugins={[dayGridPlugin]}
        initialView="dayGridMonth"
        eventContent={renderEventContent}
        events={events}
        datesSet={handleDates}
        eventClick={handleEventClick}
      />
    </>
  );
}

export default PromotionCalendar;
